import React, { useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'
import cl from './Edit.module.css'
import Pen from "../../../../assets/Icon/Pen";

const Edit = ({ shipperService, defaultShipper }) => {
    const shipperResetData = {
        id: 0,
        name: "",
        mobile: "",
        address: "",
        address2: "",
        code: "",
        country: "",
        district: "",
        city: "",
    }

    const initEditShipper = (shipper) => {
        return {
            id: shipper.id,
            name: shipper.name,
            mobile: shipper.mobile,
            address: shipper.address,
            address2: shipper.address2,
            code: shipper.code,
            country: shipper.country,
            district: shipper.district,
            city: shipper.city,
        }
    }

    const [newShipper, setNewShipper] = useState(shipperResetData)
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})

    const validateShipper = (shipper) => {
        const messages = {};
    
        if (shipper.name.length < 2) {
            messages.name = { message: 'მიუთითეთ სახელი', isValid: false };
        }
     
 
        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;  
      };

    const reValidate = () => {
        const isValidate = validateShipper(newShipper)
        
    }

    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateShipper(newShipper)
        }
      }, [newShipper, isFirstValidated]);

      useEffect(() => {
        const editedCar = initEditShipper(defaultShipper)
        setNewShipper(editedCar)
    }, [defaultShipper]);

    const [isModalOpen, setIsModalOpen] = useState(false);
 
    const saveHandle = () => {
         
        const isValidate = validateShipper(newShipper)

        if (isValidate === true) {
            shipperService.update(newShipper)
            setIsModalOpen(false)
        } else {
            setIsFirstValidated(true) 
        } 
         
    };

    const handleShipperChange = async (event) => {
        let val = event.target.value;
        setNewShipper(prevShipper => ({
            ...prevShipper,
            [event.target.name]: val
        })); 
    };

    const openAdd = () => {
        setValidates({})
        setIsModalOpen(true) 
        setIsFirstValidated(false) 
    }

    function convertToInt(str) {
        const num = parseInt(str, 10);
        return isNaN(num) ? 0 : num;
    }
 
  
    const handleShipperInt = async (event) => {
        let val = event.target.value;
        
        setNewShipper(prevShipper => ({
            ...prevShipper,
            [event.target.name]: convertToInt(val)
        })); 
    };


    const handleKeyPress = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const regex = /^[0-9]+$/; // Regular expression to match only numeric characters

        if (!regex.test(keyValue)) {
            event.preventDefault();
        }
    };
  
    return (
        <div>

            <span className={ cl.editBtn } onClick={() => openAdd()} >
                <Pen/> განახლება
            </span>

            <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>

                <div className={cl.modalHead} >
                    <h3>
                        <span className={cl.iconHead} > <Pen /></span> განახლება
                    </h3>
                </div>

                <div className={cl.groupInput}> 
                    <label>დასახელება</label>
                    <input type="textS" className={validates && validates.name ? cl.input + ' ' + cl.errorInput : cl.input}
                        placeholder="დასახელება" 
                        name="name" 
                        value={newShipper.name} 
                        onChange={handleShipperChange} 
                        autoComplete="off" />
                </div>

                <div className={cl.groupInput}> 
                    <label>მობილური</label>
                    <input type="textS" className={validates && validates.mobile ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="mobile" 
                        value={newShipper.mobile} 
                        onChange={handleShipperChange} 
                        autoComplete="off" />
                </div>

                <div className={cl.groupInput}> 
                    <label>მისამართი</label>
                    <input type="textS" className={validates && validates.address ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="address" 
                        value={newShipper.address} 
                        onChange={handleShipperChange} 
                        autoComplete="off" />
                </div>

                <div className={cl.groupInput}> 
                    <label>მისამართი 2</label>
                    <input type="textS" className={validates && validates.address2 ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="address2" 
                        value={newShipper.address2} 
                        onChange={handleShipperChange} 
                        autoComplete="off" />
                </div>

                <div className={cl.groupInput}> 
                    <label>ინდექს კოდი</label>
                    <input type="textS" className={validates && validates.code ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="code" 
                        value={newShipper.code} 
                        onChange={handleShipperChange} 
                        autoComplete="off" />
                </div>

                <div className={cl.groupInput}> 
                    <label>ქვეყანა</label>
                    <input type="textS" className={validates && validates.country ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="country" 
                        value={newShipper.country} 
                        onChange={handleShipperChange} 
                        autoComplete="off" />
                </div>
  
                <div className={cl.groupInput}> 
                    <label>რეგიონი</label>
                    <input type="textS" className={validates && validates.district ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="district" 
                        value={newShipper.district} 
                        onChange={handleShipperChange} 
                        autoComplete="off" />
                </div>
  
                <div className={cl.groupInput}> 
                    <label>ქალაქი</label>
                    <input type="textS" className={validates && validates.city ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="city" 
                        value={newShipper.city} 
                        onChange={handleShipperChange} 
                        autoComplete="off" />
                </div>
 
                <span onClick={saveHandle} className={cl.btnPrimary}>შენახვა</span>

            </Modal>
        </div>
    );
};

export default Edit;